import { useEffect } from 'react';
import { canUseDOM } from './index';
const StickyCtaAssistant = () => {
  const checkIsMobile = () => {
    const isMobile = canUseDOM && window.innerWidth <= 767;
    const footer = document.querySelector('.footer');
    if (canUseDOM) {
      if (footer && isMobile) {
        if (!footer.classList.contains('footer--extra-padding')) {
          footer.classList.add('footer--extra-padding');
        }
      }
    }
  };
  useEffect(() => {
    if (canUseDOM) {
      const footer = document.querySelector('.footer');
      const hp = document.querySelector('div[data-cy="happiness-meter"]');
      const backToTop = document.querySelector('.back-to-top');
      return () => {
        if (footer) {
          footer.classList.remove('footer--extra-padding');
        }
        if (hp) {
          hp.classList.remove('with-sticky-poi-cta');
        }
        if (backToTop) {
          backToTop.removeAttribute('data-position');
        }
      };
    }
  }, []);
  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const hp = document.querySelector('div[data-cy="happiness-meter"]');
      const backToTop = document.querySelector('.back-to-top');
      if (backToTop) {
        backToTop.setAttribute('data-position', 'with-sticky-poi-cta');
      }
      if (hp) {
        hp.classList.add('with-sticky-poi-cta');
      }
    }
    if (canUseDOM) {
      window.addEventListener('resize', checkIsMobile);
      const interval = setInterval(checkIsMobile, 1000);
      return () => {
        window.removeEventListener('resize', checkIsMobile);
        clearInterval(interval);
      };
    }
  }, []);
  return null;
};
export default StickyCtaAssistant;